import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=7d44f642&scoped=true&functional=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=7d44f642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7d44f642",
  null
  
)

export default component.exports